import { TripPinsLight } from '@ha/icons';
import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Grid, Typography, units, Card } from '@ha/dsl';
import { useIntl } from 'ha/i18n';

import TravelTimeContentForm from './TravelTimeContentForm';

export const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
    padding: units.rem(0.5),
  },
  title: {
    color: theme.palette.grey[600],
    paddingLeft: units.rem(0.5),
  },
  commuteIcon: {
    marginRight: units.rem(0.5),
  },
}));

export const TravelTimeBar: React.FC = () => {
  const classes = useStyles();
  const { T } = useIntl();

  return (
    <Card className={classes.container}>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item>
          <Grid container wrap="nowrap">
            <TripPinsLight className={classes.commuteIcon} />
            <Typography.Paragraph>
              {T('search.map.commute.location.label')}
            </Typography.Paragraph>
          </Grid>
        </Grid>
        <Grid item xs>
          <TravelTimeContentForm orientation="horizontal" />
        </Grid>
      </Grid>
    </Card>
  );
};

export default TravelTimeBar;
